import { render, staticRenderFns } from "./GraduateTrainee.vue?vue&type=template&id=2160f1c5&"
import script from "./GraduateTrainee.vue?vue&type=script&lang=js&"
export * from "./GraduateTrainee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports